import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CurrentLanguage } from '../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { CustomPaggerService } from '../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { Constant } from '../../../../../Autofacets-Core/src/app/utils/constant';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { DwoMechanicTimeCodeResponseModel } from '../../business-entities/dwo-mechanic-time-code-response.model';
import { MechanicInOutDetails } from '../../business-entities/mechanic-in-out-details.model';
import { MechanicJobTimerRequestModel } from '../../business-entities/mechanic-job-timer-request.model';
import { MechanicTimeCode } from '../../business-entities/mechanic-time-code-model';
import { MechanicTimeCodeTimerRequestModel } from '../../business-entities/mechanic-time-code-timer-request.model';
import { MechanicWorkOrderTimerRequestModel } from '../../business-entities/mechanic-work-order-timer-request.model';
import { MechanicList } from '../../business-entities/mechanicList-model';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { StampInOutRequestModel } from '../../business-entities/stamp-in-out-request.model';
import { TimeCodeResponseModel } from '../../business-entities/time-code-response.model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { WorkOrderModel } from '../../business-entities/work-order-model';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { MechanicTimeStampService } from '../../business-services/mechanic-time-stamp.service';
import { MechanicService } from '../../business-services/mechanic.service';
import * as Enums from '../../../../../Autofacets-Core/src/app/utils/enums';
import { Utility } from '../../../../../Autofacets-Core/src/app/utils/utility';
import * as moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Features } from '../../business-entities/user-role-view-model';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Subscription } from 'rxjs';

const monthNames = ['lblJanuary', 'lblFebruary', 'lblMarch', 'lblApril', 'lblMay', 'lblJune',
  'lblJuly', 'lblAugust', 'lblSeptember', 'lblOctober', 'lblNovember', 'lblDecember'
];
const weekDays = ['lblSunday', 'lblMonday', 'lblTuesday', 'lblWednesday', 'lblThursday', 'lblFriday', 'lblSaturday'];

@Component({
  selector: 'app-time-stamp',
  templateUrl: './time-stamp.component.html',
  styleUrls: ['./time-stamp.component.css']
})
export class TimeStampComponent implements OnInit, OnDestroy {
  time = { hour: 13, minute: 30 };
  //#region Declaration
  dealerId: string = '';
  closeResult = '';
  mechanicId: number = 0;
  mechanicList: MechanicList[];
  summaryList: TimeCodeResponseModel[];
  timeCodeList: DwoMechanicTimeCodeResponseModel[];
  stampInOutRequestModel: StampInOutRequestModel;
  mechanicInOutDetailsModel: MechanicInOutDetails;
  mechanicInOutDetailsList: any;
  mechanicWorkOrderTimerModel: MechanicWorkOrderTimerRequestModel;
  mechanicJobTimerModel: MechanicJobTimerRequestModel;
  isNormal: boolean = true;
  dayType: number = 0;
  timeCodeId: number = 0;
  langCode = '';
  d = new Date();
  date: string;
  day: string;
  month: string;
  isNormalOut: boolean = false;
  isWOSummary: boolean = false;
  assignedWork: string = null;
  mechanicTimeCode: MechanicTimeCode;
  dealerList: Array<SelectListItemViewModel>;
  stampInButton: boolean = false;
  stampOutButton: boolean = false;
  stampInOverTimeButton: boolean = false;
  stampOutOverTimeButton: boolean = false;
  isMechanicSelected: boolean = false;
  isViewSummary: boolean = false;
  timeCodeStart: boolean = false;
  timeCodeStop: boolean = false;
  timeCodeDetails: any;
  woStartButton: boolean = false;
  woStopButton: boolean = false;
  woSummaryButton: boolean = false;
  WoSelect: boolean = false;
  workOrderNumber: string;
  workOrderSummaryList: any[];
  mechanicTimeCodeRequestModel: MechanicTimeCodeTimerRequestModel;
  mechanicStampInOutDetails: any;
  jobList: any[];
  jobDetailsList: any[];
  WoCounter: number;
  isJobTimer: boolean = false;
  selectedWO: string = null;
  selectedJob: string = null;
  selectedDayType = 1;
  selecteMechanic = 0;
  workOrderList: WorkOrderModel[];
  appointmentId: number;
  appointmentJobId: number;
  appointmentJobDetailId: number;
  checkCurrentDt: boolean = true;
  selectedTc = 0;
  userRoleRightsDetails: UserRoleMenu;
  isDealerLoggedIn: boolean;
  timeCodeLangList: any[];
  timePicker: boolean = false;
  inTimePicker: boolean = false;
  allowedTimesForSlotFrom: string[][] = [];
  allowedTimesForSlotTo: string[][] = [];
  allTimeStamps: string[] = [];
  zeroTime = '00:00';
  inTime: any;
  closingTimeHour: any;
  closingTimeMinute: any;
  selectedOutTime: any = '';
  isToday: boolean = true;
  dealerSelected: string;
  mechanicShift: string = '';
  showDate: any;
  closeModel: any;
  FromTimeObj: any = { hour: 0, minute: 0 };
  ToTimeObj: any = { hour: 0, minute: 0 };;
  FromDate: any;
  TimeToDate: any = null;
  summaryReason: any;
  woSummaryform: FormGroup;
  stampOutDate: any = new Date();
  popupCloseResult = false;
  stopTime: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  startTime: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  shiftStartTime = new Date();
  shiftEndTime = new Date();
  timeCodeStartTime: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  timeCodeStopTime: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  stampStartDate: string = Utility.GetFormattedDate(new Date());
  stampEndDate: string = Utility.GetFormattedDate(new Date());
  today: string = Utility.GetFormattedDate(new Date());
  CurrentWoId: any;
  CurrentJobId: any;
  CurrentTimeCodeId: any;
  timeCodeResponse: any;
  openingTimeHour: any;
  openingTimeMinute: any;
  stampInDate: any = new Date();
  selectedId: number;
  selectedStartTime: any;
  featureList: Features[] = [];
  isWorkorderTimer: boolean = false;
  isJobDetailsTimerFeature: boolean = false;
  selectedJobDetail: string = null;
  isJobDetailTimer: boolean = false;
  @ViewChild('workOrder') WorkOderRef: ElementRef;
  subscription: Subscription;
  //#endregion

  //#region Constructor & OnInit
  constructor(
    private readonly mechanicService: MechanicService,
    private readonly service: MechanicTimeStampService,
    private readonly spinner: NgxSpinnerService,
    public pService: CustomPaggerService,
    private readonly datepipe: DatePipe,
    private readonly translate: TranslateService,
    private readonly decimalPipe: DecimalPipe,
    private readonly dealerBusinessService: DealerBusinessService,
    private readonly toastr: ToastrService,
    private readonly modalService: NgbModal,
    private readonly formBuilder: FormBuilder,
    private readonly userService: UserDataService,
    private readonly datePipe: DatePipe,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly secureStorage: SecureStorage,
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = [];
    this.pService.searchTerm = '';

    this.stampInOutRequestModel = {
      id: 0,
      mechanicId: 0,
      type: 0,
      normal: true,
      userId: 0,
      isStampIn: true
    };
    this.mechanicTimeCodeRequestModel = {
      mechanicId: 0,
      timeCodeId: 0,
      appointmentId: 0,
      userId: 0,
      time: null
    };
    this.mechanicWorkOrderTimerModel = {
      appointmentId: 0,
      mechanicId: 0,
      userId: 0,
      startTime: null
    };
    this.mechanicJobTimerModel = {
      appointmentId: 0,
      mechanicId: 0,
      userId: 0,
      appointmentJobId: 0,
      time: null
    };
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.dealerSelected = this.userService.currentUserValue.defaultDealerId ?? '';
    this.dealerId = this.dealerSelected;
    this.userRoleRightsDetails = (this.userService.currentUserValue
      .userRoleMenuDetails as any[]).find(
        menu => menu.moduleId === fromEnums.ModuleNames.TimeStamp
      );
    this.getFeatures();
    this.getDate();
    this.getUserDealers();
    this.getLanguage();
    this.woSummaryform = this.formBuilder.group({
      timefrom: [{ value: '' }, [Validators.required]],
      timeto: [{ value: '' }, [Validators.required]],
      reason: ['', [Validators.required]],
    })
    this.stampInOutRequestModel.isToStampOutPreviousDays = localStorage.getItem("Theme") === 'bnh' || 'afx'? true : false;
      this.GetMechanicList(this.dealerId);
      this.getWorkOrderList(this.dealerId);
  }
  //#endregion
  async getFeatures() {
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList && this.featureList.length > 0) {
        this.isWorkorderTimer = this.featureList.find(x => x.featureCode === Enums.FeatureCode.WorkorderTimer)?.isActive;
        this.isJobDetailsTimerFeature = this.featureList.find(x => x.featureCode === Enums.FeatureCode.JobDetailsTimer)?.isActive;
      }
      else {
        this.subscription = this.currentLanguageService.featureList.subscribe((res) => {
          this.featureList = res;
          if (this.featureList && this.featureList.length > 0) {
            this.isWorkorderTimer = this.featureList.find(x => x.featureCode === Enums.FeatureCode.WorkorderTimer)?.isActive;
            this.isJobDetailsTimerFeature = this.featureList.find(x => x.featureCode === Enums.FeatureCode.JobDetailsTimer)?.isActive;
          }
        })
      }
    }
  }
  //#region Page Methods
  onRefreshClick() {
    this.ngOnInit();
  }
  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element => {
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }
  get frm() {
    return this.woSummaryform.controls;
  }
  getAll() {
    this.initializeAllTimeStamps();
  }
  initializeAllTimeStamps(): void {
    this.allTimeStamps = []
    const totalHoursInDay = 24;
    const totalMinsInHour = 60;
    const timeDifferenceInMins = 15;
    for (let i = 0; i < totalHoursInDay; i++) {
      for (let j = 0; j < totalMinsInHour; j += timeDifferenceInMins) {
        const time = `${this.decimalPipe.transform(i, '2.0-0')}:${this.decimalPipe.transform(j, '2.0-0')}`;
        this.allTimeStamps.push(time);
      }
    }
    const closingTimeIndex = this.allTimeStamps.findIndex(x => +x.split(":")[0] === this.closingTimeHour && +x.split(":")[1] >= this.closingTimeMinute);
    this.allTimeStamps = closingTimeIndex > -1 ? this.allTimeStamps.slice((closingTimeIndex), (this.allTimeStamps.length - 1)) : this.allTimeStamps.slice();
    this.selectedOutTime = this.allTimeStamps[0];
  }
  setAllowedOpeningTime(index: number, closingTime: string): void {
    const closingTimeIndex = this.allTimeStamps.findIndex(x => x === closingTime);
    this.allowedTimesForSlotFrom[index] = closingTimeIndex > -1 ? this.allTimeStamps.slice(0, closingTimeIndex) : this.allTimeStamps.slice();
  }
  onDealerSelected(dealerId: string) {
    let id = dealerId ?? '';
    this.dealerId = id;
    if (!dealerId) {
      this.mechanicList = null;
    }
    this.selectedDealer(id);
  }
  selectedDealer(dealerId, isFormated = false) {
    if (isFormated && this.isDealerLoggedIn) {
      this.dealerId = dealerId;
    }
    this.isMechanicSelected = false;
    this.selecteMechanic = 0;
    if (this.dealerId) {
      this.GetMechanicList(this.dealerId);
      this.getWorkOrderList(this.dealerId);
    }
  }
  getDate() {
    this.date = this.datepipe.transform(this.d, 'dd');
    this.month = monthNames[this.d.getMonth()];
    this.day = weekDays[this.d.getDay()];
    this.showDate = moment(this.d).format("ddd, DD MMM YYYY");
    this.stampOutDate = moment(this.d);
    this.stampInDate = moment(this.d).format("DD.MM.YYYY");
    this.stampStartDate = Utility.GetFormattedDate(this.stampOutDate);
    this.stampOutDate = this.stampOutDate.format("DD.MM.YYYY");
  }
  onChangeDate(event) {
    this.d = new Date(event);
    this.stampOutDate = moment(this.d);
    this.stampInDate = moment(this.d).format("DD.MM.YYYY");
    this.stampOutDate = this.stampOutDate.format("DD.MM.YYYY");
    this.stampStartDate = this.stampOutDate;
    this.date = this.datepipe.transform(this.d, 'dd');
    this.month = monthNames[this.d.getMonth()]
    this.day = weekDays[this.d.getDay()]
    this.showDate = moment(this.d).format("ddd, DD MMM YYYY");
    this.getWorkOrderList(this.dealerId);
    this.checkCurrentDate(this.d);
    const today = new Date();
    if (this.d.getDate() === today.getDate() && this.d.getMonth() === today.getMonth() && this.d.getFullYear() === today.getFullYear()) {
      this.isToday = true;
    }
    else {
      this.isToday = false;
    }
    this.initialize();
    this.getTimeCodeDetails(this.mechanicId, this.d);
    this.getMechanicStampInOutDetails(this.d);
    this.stampInButtonChange();
  }
  stampInButtonChange(){
     if(!this.isToday && this.d <= new Date()){
      this.stampInButton = true;
    }
    else if(this.d > new Date()){
      this.stampInButton = false;
      this.stampOutButton = false;
    }
  }
  onChangeStampOutDate(event) {
    this.stampOutDate = moment(event).format("DD.MM.YYYY");
  }
  stampOut(data: any) {
    this.closingTimeHour = data.stampIn.getHours();
    this.closingTimeMinute = data.stampIn.getMinutes();
    if (this.closingTimeMinute >= 45 && this.closingTimeMinute <= 60) {
      this.closingTimeMinute = 0;
      if (this.closingTimeHour !== 23) {
        this.closingTimeHour = this.closingTimeHour + 1;
      }
      else {
        this.closingTimeHour = 0
      }
    }
    data.timePicker = !data.timePicker;
    this.getAll();
  }
  checkStampIn() {
    if (this.mechanicStampInOutDetails.filter(x => x.stampOut === null && x.normal).length > 0) {
      this.stampInButton = false;
      this.stampOutButton = true;
      this.stampInOverTimeButton = false;
      this.stampOutOverTimeButton = false;
      this.WoSelect = true;
      this.getCurrentWO();
    }
    else if (this.mechanicStampInOutDetails.filter(x => x.stampOut === null && !x.normal).length > 0) {
      this.stampInButton = false;
      this.stampOutButton = false;
      this.stampInOverTimeButton = false;
      this.stampOutOverTimeButton = true;
      this.WoSelect = true;
      this.getCurrentWO();
    }
    else if (this.isToday) {
      this.stampInButton = true;
      this.stampOutButton = false;
      this.stampInOverTimeButton = true;
      this.stampOutOverTimeButton = false;
      this.WoSelect = false;
    }
    else if(this.d > new Date()){
      this.stampInButton = false;
      this.stampOutButton = false;
    }
    else {
      this.stampInOverTimeButton = false;
      this.stampOutOverTimeButton = false;
      this.WoSelect = true;
    }
  }
  selectedWorkOrder(e: any) {
    this.appointmentId = this.workOrderList.find(
      x => x.workOrderNumber === e
    ).appointmentId;
    this.workOrderNumber = e;
    this.woStartButton = true;
    this.woStopButton = false;
    this.woSummaryButton = true;
    this.selectedJob = null;
    this.isJobTimer = false;
    this.isJobDetailTimer = false;
    this.selectedStartTime = this.d;
    this.selectedJobDetail = null;
    this.getJobList(this.workOrderNumber);
  }
  selectDayType(e: any) {
    e = e.split(':');
    this.dayType = e[0];
    if (!this.checkCurrentDt) {
      //this.stampInButton = false;
      this.stampOutButton = false;
      this.stampInOverTimeButton = false;
      this.stampOutOverTimeButton = false;
    } else {
      this.stampInButton = true;
      this.stampInOverTimeButton = true;
    }
  }
  async getLanguage() {
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.langCode = x;
      this.selectTimeCode(this.dealerId, this.langCode);
    });
  }
  ViewSummaryClick(content) {
    this.ViewSummary();
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        result => {
          this.closeResult = `Closed with: ${result}`;
        },
        reason => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  selectedMechanic(e: any) {
    this.isMechanicSelected = true;
    e = e.split(':');
    this.mechanicId = e[1];
    this.initialize();
    if (this.checkCurrentDt) {
      this.stampInButton = true;
    }
    this.woStopButton = false;
    this.getMechanicStampInOutDetails(this.d);
    this.selectTimeCode(this.dealerId, this.langCode);
    this.getTimeCodeDetails(this.mechanicId, this.d);
    this.ViewSummary();
  }
  selectedTimeCode(e: any) {
    e = e.split(': ');
    this.timeCodeId = e[1];
    this.timeCodeStart = true;
    this.selectedStartTime = this.d;
  }
  closeSummary() {
    this.isViewSummary = false;
  }
  stop() {
    this.selectedTc = 0;
    this.selectedWO = null;
    this.selectedJob = null;
    this.selectedDayType = 1;
    this.WoSelect = false;
    this.woStartButton = false;
    this.woSummaryButton = false;
    this.woStopButton = false;
    this.timeCodeStop = false;
    this.timeCodeStart = false;
  }
  stampInOutDetails() {
    const dayDate = new Date(Utility.getDateStringToDate(this.stampOutDate));
    const dayDateTime = new Date();
    dayDate.setHours(dayDateTime.getHours());
    dayDate.setMinutes(dayDateTime.getMinutes());
    dayDate.setSeconds(dayDateTime.getSeconds());
    this.stampInOutRequestModel.mechanicId = this.mechanicId;
    this.stampInOutRequestModel.normal = true;
    this.stampInOutRequestModel.type = this.dayType;
    this.stampInOutRequestModel.time = Utility.getDateStringToDate(this.stampOutDate);
    this.stampInOutRequestModel.stampOutTime = dayDate.toISOString();
    this.stampInOutRequestModel.isManualStamp = true;
  }
  todaysData() {
    this.d = new Date();
    this.onChangeDate(this.d);
  }
  getPreviousDate() {
    this.d = new Date(this.d.setDate(this.d.getDate() - 1));
    this.onChangeDate(this.d);
    this.stampInButtonChange();
  }
  getNextDate() {
    this.d = new Date(this.d.setDate(this.d.getDate() + 1));
    this.onChangeDate(this.d);
    this.stampInButtonChange();
  }
  checkCurrentDate(date) {
    date = this.datepipe.transform(date, 'yyyy MMM dd');
    let d = this.datepipe.transform(new Date(), 'yyyy MMM dd');
    if (date != d) {
      this.checkCurrentDt = false;
    } else this.checkCurrentDt = true;
  }
  getWeekday(d) {
    let weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";
    return weekday[d.getDay()];
  }
  getTime(totaltime) {
    let hr = Math.floor(totaltime);
    let min = Math.floor((totaltime - hr) * 60).toFixed(0);
    if (min.toString().length == 1) {
      return hr + ' : 0' + min;
    }
    return hr + ' : ' + min;
  }
  initialize() {
    if (this.checkCurrentDt) {
     // this.stampInButton = true;
      this.stampInOverTimeButton = true;
    } else {
      //this.stampInButton = false;
      this.stampInOverTimeButton = false;
    }
    if(this.d <= new Date()){
      this.stampInButton = true;
    }
    else{
      this.stampInButton = false;
    }
    this.selectedJob = null;
    this.selectedJobDetail = null;
    this.selectedWO = null;
    this.selectedDayType = 1;
    this.stampOutButton = false;
    this.stampOutOverTimeButton = false;
    this.assignedWork = null;
    this.stopTime = { hour: 0, minute: 0, second: 0 };
    this.startTime = { hour: 0, minute: 0, second: 0 };
    this.timeCodeStartTime = { hour: 0, minute: 0, second: 0 };
    this.timeCodeStopTime = { hour: 0, minute: 0, second: 0 };
    this.selectedTc = null;
    this.workOrderNumber = null;
  }
  selectJob(e: any) {
    e = e.split(':');
    this.appointmentJobId = e[1];
    this.woStartButton = true;
    this.woSummaryButton = true;
    this.isJobTimer = true;
    this.isJobDetailTimer = false;
    this.selectedStartTime = this.d;
    if (this.appointmentJobId > 0) {
      this.getJobDetailsList(this.appointmentJobId);
    }
  }
  selectJobDetail(e: any) {
    e = e.split(':');
    this.isJobDetailTimer = true;
    this.appointmentJobDetailId = e[1];
  }
  //#endregion

  //#region API Methods
  async getUserDealers() {
    this.spinner.show();
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      if (this.dealerList.length === 1) {
        this.dealerSelected = this.dealerList[0].value;
        this.GetMechanicList(this.dealerSelected);
        this.getWorkOrderList(this.dealerSelected);
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  onChangeOpeningHours(data: any, event: any) {
    let inTime = data.stampIn;
    let outTime = Utility.getDateStringToDate(this.stampOutDate);
    outTime.setHours(+event.split(":")[0], +event.split(":")[1], 0);
    let startTime = this.mechanicShift.split('-')[0];
    let startTimeData = startTime?.split(':');
    let shiftStartTime = startTimeData[0] + ':' + (+startTimeData[1] - 1 );
    let endTime = this.mechanicShift.split('-')[1];
    let endTimeData = endTime?.split(':');
    let endShiftTime = endTimeData[0] + ':' + (+endTimeData[1] + 1);
    let isBetweenShift = Utility.IsInBetweenTime(shiftStartTime, endShiftTime, event);
    if (inTime < outTime) {
      let model = {
        Id: data.id,
        StampOut: outTime,
        StampIn: new Date(inTime),
        MechanicId: this.mechanicId
      }
      this.spinner.show();
      this.service.UpdateMechanicStampOutDetails(model).then((res) => {
        if (res.responseObject) {
          this.woStartButton = false;
          this.woStopButton = false;
          this.timeCodeStart = false;
          this.timeCodeStop = false;
          this.assignedWork = null;
          this.selectedWO = null;
          this.selectedJob = null;
          this.selectedDayType = 1;
          this.WoSelect = false;
          this.woSummaryButton = false;
          this.getMechanicStampInOutDetails(this.d);
          this.getTimeCodeDetails(this.mechanicId, this.d);
        }
        else {
          let msg = this.translate.instant('lblStampOutTimeNotLesserThenJobEndTime');
          this.toastr.error(msg);
        }
      }).finally(() => {
        this.spinner.hide();
      });
    }
    else{
      let warningMessage = this.translate.instant('lblEndTimeGraterWarning');
      this.toastr.warning(warningMessage);
      return;
    }
    if(!isBetweenShift) {
      let warningMessage = this.translate.instant('lblEndShiftTimeWarning');
      this.toastr.warning(warningMessage);
    }
  }
  async getMechanicStampInOutDetails(d) {
    this.spinner.show();
    await this.service
      .GetMechanicStampInOutDetails(this.mechanicId, d)
      .then(response => {
        this.mechanicStampInOutDetails = [];
        if (response.responseCode == Constant.SuccessResponseCode) {
          if (response.responseObject.length > 0) {
            let openHours = (response.responseObject[0].openingHours ? this.datePipe.transform(response.responseObject[0].openingHours, 'HH:mm') : "00:00");
            let closeHours = (response.responseObject[0].closingHours ? this.datePipe.transform(response.responseObject[0].closingHours, 'HH:mm') : "00:00");
            this.mechanicShift = openHours + '-' + closeHours;
            let startHour = Number(openHours.split(':')[0]);
            let startMinute = Number(openHours.split(':')[1]);
            let endHour = Number(closeHours.split(':')[0]);
            let endMinute = Number(closeHours.split(':')[1]);
            this.shiftStartTime.setHours(startHour)
            this.shiftStartTime.setMinutes(startMinute)
            this.shiftStartTime.setSeconds(0)
            if (endHour == 0 && endMinute == 0) {
              this.shiftEndTime.setHours(23);
              this.shiftEndTime.setMinutes(59);
              this.shiftEndTime.setSeconds(59);
            }
            else {
              this.shiftEndTime.setHours(endHour);
              this.shiftEndTime.setMinutes(endMinute);
              this.shiftEndTime.setSeconds(0);
            }
            if (response.responseObject[0].id != 0) {
              this.mechanicStampInOutDetails = response.responseObject;
              this.mechanicStampInOutDetails.forEach(element => {
                element.stampIn = new Date(element.stampIn + 'Z');
                if (element.stampOut !== null) {
                  element.stampOut = new Date(element.stampOut + 'Z');
                  element.isNormalOut = true;
                  element.timePicker = false;
                  element.inTimePicker = false;
                }
                else {
                  element.isNormalOut = false;
                  element.timePicker = false;
                  element.inTimePicker = false;
                }
              });
              this.checkStampIn();
            }
          }
        }
      }).finally(() => {
        this.spinner.hide();
      });
  }
  async getWorkOrderList(dealerId) {
    this.spinner.show();
    await this.service.GetWorkOrders(dealerId).then(res => {
      this.workOrderList = res.responseObject;
    }).finally(() => {
      this.spinner.hide();
    });
  }
  async GetMechanicList(id: string) {
    this.spinner.show();
    await this.mechanicService.GetMechanicList(id, Enums.StatusCode.All).then(response => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.mechanicList = response.responseObject;
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  async getCurrentWO() {
    this.spinner.show();
    await this.service.GetCurrentWO(this.mechanicId).then(response => {
      let r = response.responseObject;
      if (r?.jobDescription) {
        this.assignedWork = r.jobDescription;
        this.selectedWO = r.workOrderNo;
        this.selectedJob = r.jobId;
        this.appointmentJobId = r.jobId;
        this.WoSelect = false;
        this.isJobTimer = true;
        this.woStartButton = false;
        this.woSummaryButton = true;
        this.woStopButton = true;
        this.WoCounter = 1;
        this.appointmentId = r.appointmentId;
        this.CurrentJobId = r.jobId;
        this.selectedId = r.id;
        this.selectedStartTime = r.startTime;
        this.getJobList(r.workOrderNo);
        if(this.isJobDetailsTimerFeature){
          this.getJobDetailsList(r?.jobId);
        }
      }
      else if (r?.workOrderNo) {
        this.assignedWork = r.workOrderNo;
        this.selectedWO = this.assignedWork;
        this.WoSelect = false;
        this.isJobTimer = false;
        this.woSummaryButton = true;
        this.woStartButton = false;
        this.woStopButton = true;
        this.WoCounter = 0;
        this.CurrentWoId = r.workOrderNo;
        this.appointmentId = r.appointmentId;
        this.selectedId = r.id;
        this.selectedStartTime = r.startTime;
        this.isJobDetailTimer = false;
      } else if (r?.timeCodeDescription) {
        this.assignedWork = r.timeCodeDescription;
        this.WoSelect = false;
        this.isJobTimer = false;
        this.isJobDetailTimer = false;
        this.timeCodeStart = false;
        this.timeCodeStop = true;
        this.CurrentTimeCodeId = r.timeCodeId;
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  async getTimeCodeDetails(mechanicId, date) {
    this.spinner.show();
    await this.service.GetTimeCodeDetails(mechanicId, date).then(response => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.timeCodeDetails = response.responseObject;
        this.timeCodeDetails.forEach(element => {
          element.startDateTime = new Date(element.startTime + 'Z');
          element.endDateTime = new Date(element.endTime + 'Z');
          if(element.timerTypeId == fromEnums.TimerType.WorkOrder){
            element.timerType = "lblWorkorderTimer"
          }
          if(element.timerTypeId == fromEnums.TimerType.Job){
            element.timerType = "lblJobTimer"
          }
          if(element.timerTypeId == fromEnums.TimerType.JobDetail){
            element.timerType = "lblJobDetailTimer"
          }
          if(element.timerTypeId == fromEnums.TimerType.TimeCode){
            element.timerType = "lblTimeCodeTimer"
          }
        });
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  async timeCodeStartClick(time) {
    if(time?.hour == 0 && time?.minute == 0)
    {
      this.toastr.error(this.translate.instant("lblValidTime"));
    }
    else{
      var startDateTime = new Date();
      startDateTime.setHours(this.timeCodeStartTime.hour)
      startDateTime.setMinutes(this.timeCodeStartTime.minute)
      // var isBetweenShift = Utility.IsInBetweenDateTime(this.shiftStartTime, this.shiftEndTime, startDateTime)
      //if (!this.stampInOutRequestModel.normal) {
      // if (!this.stampInOutRequestModel.normal || isBetweenShift) {
      this.d.setHours(time.hour);
      this.d.setMinutes(time.minute);
      this.mechanicTimeCodeRequestModel.timeCodeId = this.timeCodeId;
      this.mechanicTimeCodeRequestModel.mechanicId = this.mechanicId;
      this.mechanicTimeCodeRequestModel.appointmentId = this.appointmentId;
      this.mechanicTimeCodeRequestModel.time = this.d
      this.timeCodeStartTime = time;
      this.spinner.show();
      await this.service
        .StartTimeCodeTimer(this.mechanicTimeCodeRequestModel)
        .then(res => {
          if (res.responseObject) {
            this.timeCodeStart = false;
            this.timeCodeStop = true;
            this.woStartButton = false;
            this.woStopButton = false;
            this.getCurrentWO();
            this.getTimeCodeDetails(this.mechanicId, this.d);
          } else {
            let errorMessage = this.translate.instant('lblErrorMessage');
            this.toastr.error(errorMessage);
          }
        }).finally(() => {
          this.spinner.hide();
        });
      // }
      // else {
      //   let warningMessage = this.translate.instant('lblStartTimeWarning');
      //   this.toastr.warning(warningMessage);
      // }
    }
  }
  async timeCodeStopClick(time) {
    if(time?.hour == 0 && time?.minute == 0)
      {
        this.toastr.error(this.translate.instant("lblValidTime"));
      }
    else{
    var startTime = new Date();
    startTime.setHours(this.timeCodeStartTime.hour)
    startTime.setMinutes(this.timeCodeStartTime.minute)
    var stopDateTime = new Date();
    stopDateTime.setHours(time.hour)
    stopDateTime.setMinutes(time.minute)
    if (this.compareOnlyDate(this.selectedStartTime, stopDateTime)) {
      this.timeCodeStopAction(startTime, stopDateTime, time);
    }
    else {
      let modelHeadermsg = this.translate.instant("lblDelete");
      let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblSummary"), false);
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg + Utility.GetFormattedDateTime(this.selectedStartTime);
      modalRef.result.then((_result) => {
        // This is intentional
      }, (reason) => {
        this.closeModel = this.getDismissReason(reason);
        if (this.closeModel) {
          this.timeCodeStopAction(startTime, stopDateTime, time);
        }
      })
    }
  }

  }
  async timeCodeStopAction(startTime, stopDateTime, time) {
    //var isBetweenShift = Utility.IsInBetweenDateTime(this.shiftStartTime, this.shiftEndTime, stopDateTime)
    //if (startTime < stopDateTime && (!this.stampInOutRequestModel.normal || isBetweenShift)) {
    if (startTime < stopDateTime) {
      this.d.setHours(time.hour);
      this.d.setMinutes(time.minute);
      this.mechanicTimeCodeRequestModel.timeCodeId = this.timeCodeId;
      this.mechanicTimeCodeRequestModel.mechanicId = this.mechanicId;
      this.mechanicTimeCodeRequestModel.appointmentId = this.appointmentId;
      this.mechanicTimeCodeRequestModel.time = this.d
      this.timeCodeStopTime = time;
      this.spinner.show();
      await this.service
        .StopTimeCodeTimer(this.mechanicTimeCodeRequestModel)
        .then(res => {
          if (res.responseObject) {
            this.timeCodeStop = false;
            this.assignedWork = null;
            this.selectedWO = null;
            this.selectedJob = null;
            this.selectedTc = 0;
            this.WoSelect = true;
            this.woSummaryButton = true;
            this.getTimeCodeDetails(this.mechanicId, this.d);
            let successMessage = this.translate.instant('lblStopped');
            this.toastr.success(successMessage);
          } else {
            let errorMessage = this.translate.instant('lblErrorMessage');
            this.toastr.error(errorMessage);
          }
        }).finally(() => {
          this.spinner.hide();
        });
      this.timeCodeStartTime = { hour: 0, minute: 0, second: 0 };
      this.timeCodeStopTime = { hour: 0, minute: 0, second: 0 };
    }
    else {
      let warningMessage = this.translate.instant('lblEndTimeWarning');
      this.toastr.warning(warningMessage);
    }
  }
  stampInClick() {
    this.stampInButton = false;
    this.timeCodeStart = false;
    this.stampInOutDetails();
    this.stampInOutRequestModel.isStampIn = true;
    let successMessage = this.translate.instant('lblAddedSuccessfully');
    let errorMessage = this.translate.instant('lblErrorMessage');
    this.spinner.show();
    this.service.MechanicStampIn(this.stampInOutRequestModel).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.toastr.success(successMessage);
        this.stampOutButton = true;
        this.stampInOverTimeButton = false;
        this.stampOutOverTimeButton = false;
        this.timeCodeStart = true;
        this.WoSelect = true;
        this.getMechanicStampInOutDetails(this.d);
      } else this.toastr.error(errorMessage);
    }).finally(() => {
      this.spinner.hide();
    });
  }
  stampOutClick() {
    this.stampInButton = true;
    this.stampInOutDetails();
    this.stampInOutRequestModel.isStampIn = false;
    let successMessage = this.translate.instant('lblStampOutSuccessfully');
    let errorMessage = this.translate.instant('lblErrorMessage');
    this.spinner.show();
    this.service.MechanicStampOut(this.stampInOutRequestModel).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.toastr.success(successMessage);
        this.woStartButton = false;
        this.woStopButton = false;
        this.timeCodeStart = false;
        this.timeCodeStop = false;
        this.assignedWork = null;
        this.selectedWO = null;
        this.selectedJob = null;
        this.selectedDayType = 1;
        this.WoSelect = false;
        this.woSummaryButton = false;
        this.getMechanicStampInOutDetails(this.d);
        this.stop();
      } else this.toastr.error(errorMessage);
    }).finally(() => {
      this.spinner.hide();
    });
    if (this.checkCurrentDt) {
      this.stampInButton = true;
      this.stampInOverTimeButton = true;
    } else {
      this.selectedDayType = 1;
    }
    this.stampOutButton = false;
    this.stampOutOverTimeButton = false;
  }
  stampInForOverTimeClick() {
    this.stampInOutDetails();
    this.stampInOutRequestModel.isStampIn = true;
    this.stampInOutRequestModel.normal = false;
    let successMessage = this.translate.instant('lblAddedSuccessfully');
    let errorMessage = this.translate.instant('lblErrorMessage');
    this.spinner.show();
    this.service.MechanicStampIn(this.stampInOutRequestModel).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.stampInButton = false;
        this.stampOutButton = false;
        this.stampInOverTimeButton = false;
        this.stampOutOverTimeButton = true;
        this.timeCodeStart = true;
        this.WoSelect = true;
        this.getMechanicStampInOutDetails(this.d);
        this.toastr.success(successMessage);
      } else this.toastr.error(errorMessage);
    }).finally(() => {
      this.spinner.hide();
    });
  }
  stampOutForOverTimeClick() {
    this.stampInOutDetails();
    this.stampInOutRequestModel.isStampIn = false;
    this.stampInOutRequestModel.normal = false;
    let successMessage = this.translate.instant('lblAddedSuccessfully');
    let errorMessage = this.translate.instant('lblErrorMessage');
    this.spinner.show();
    this.service.MechanicStampOut(this.stampInOutRequestModel).then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.toastr.success(successMessage);
        this.stampInButton = true;
        this.stampOutButton = false;
        this.stampInOverTimeButton = true;
        this.stampOutOverTimeButton = false;
        this.woStartButton = false;
        this.woStopButton = false;
        this.timeCodeStart = false;
        this.timeCodeStop = false;
        this.assignedWork = null;
        this.selectedWO = null;
        this.selectedJob = null;
        this.selectedDayType = 1;
        this.WoSelect = false;
        this.woSummaryButton = false;
        this.getMechanicStampInOutDetails(this.d);
      } else this.toastr.error(errorMessage);
    }).finally(() => {
      this.spinner.hide();
    });
  }
  async ViewSummary() {
    this.isViewSummary = true;
    this.spinner.show();
    await this.service.GetSummaryDetails(this.mechanicId, this.d).then(res => {
      this.summaryList = res;
    }).finally(() => {
      this.spinner.hide();
    });
  }
  async selectTimeCode(dealerId, langCode) {
    this.spinner.show();
    await this.service.GetMechanicTimeCodes(dealerId, langCode).then(res => {
      this.timeCodeList = res.responseObject;
      if (this.timeCodeList && this.timeCodeList.length > 0) {
        this.timeCodeLangList = this.timeCodeList.map(x => {
          return {
            Id: x.id,
            Code: x.timeCodeEn,
            Description: x.descriptionEn
          };
        });
      }
    }).finally(() => {
      this.spinner.hide();
    });
  }
  async getJobList(workOrder: string) {
    this.spinner.show();
    await this.service.GetJobsByWO(workOrder).then(res => {
      this.jobList = res.responseObject;
    }).finally(() => {
      this.spinner.hide();
    });
  }
  async getJobDetailsList(jobId: number) {
    this.spinner.show();
    await this.service.GetJobDetailByWO(jobId).then(res => {
      this.jobDetailsList = res.responseObject;
    }).finally(() => {
      this.spinner.hide();
    });
  }
  onWOStartButton(startTime) {
    if(startTime?.hour == 0 && startTime?.minute == 0)
      {
        this.toastr.error(this.translate.instant("lblValidTime"));
      }
      else{
    var startDateTime = new Date();
    startDateTime.setHours(this.startTime.hour)
    startDateTime.setMinutes(this.startTime.minute)
    // var isBetweenShift = Utility.IsInBetweenDateTime(this.shiftStartTime, this.shiftEndTime, startDateTime)
    // if (!this.stampInOutRequestModel.normal || isBetweenShift) {
    // if (!this.stampInOutRequestModel.normal) {
    this.d.setHours(startTime.hour);
    this.d.setMinutes(startTime.minute);
    this.startTime = startTime
    this.woStartButton = false;
    this.woSummaryButton = true;
    this.woStopButton = true;
    this.mechanicJobTimerModel.mechanicId = this.mechanicId;
    this.mechanicJobTimerModel.appointmentId = this.appointmentId;
    this.mechanicJobTimerModel.appointmentJobId = this.appointmentJobId;
    this.mechanicJobTimerModel.time = this.d;
    this.mechanicJobTimerModel.appointmentJobDetailId = this.appointmentJobDetailId;
    this.mechanicWorkOrderTimerModel.mechanicId = this.mechanicId;
    this.mechanicWorkOrderTimerModel.appointmentId = this.appointmentId;
    this.mechanicWorkOrderTimerModel.startTime = this.d
    //#region  If workorder feature is on
    if (this.isWorkorderTimer && !this.isJobDetailsTimerFeature) {
      if (this.isJobTimer) {
        this.startJobTimer()
      } else {
        this.startWorkorderTimer();
      }
    }
    //#endregion

    //#region If JobDetails feature is on
    if (!this.isWorkorderTimer && this.isJobDetailsTimerFeature) {
      //#region  Job details timer
      if (this.isJobDetailTimer) {
        this.startJobDetailTimer()
      }
      //#endregion
      //#region Job timer
      else if (this.isJobTimer && !this.isJobDetailTimer) {
        this.startJobTimer()
      }
      else if(this.selectedWO?.length > 0 ||this.workOrderNumber?.length > 0){
        this.toastr.warning(this.translate.instant("lblAnySelectJob"))
      }
      //#endregion
    }
    //#endregion

    //#region  If Workorder timer + JobDetail time feature both on
    if (this.isWorkorderTimer && this.isJobDetailsTimerFeature) {
      //#region  Job details timer
      if (this.isJobDetailTimer) {
        this.startJobDetailTimer();
      }
      //#endregion
      //#region Job timer
      else if (this.isJobTimer && !this.isJobDetailTimer) {
        this.startJobTimer();
      }
      //#endregion
      //#region Workorder timer
      else {
        this.startWorkorderTimer();

      }
      //#endregion
    }
  }
    //#endregion
  }
  startWorkorderTimer() {
    if (this.selectedWO?.length > 0 ||this.workOrderNumber?.length > 0) {
      this.spinner.show();
      this.service
        .StartWorkOrderTimer(this.mechanicWorkOrderTimerModel)
        .then(_resp => {
          let successMessage = this.translate.instant('lblStarted');
          this.toastr.success(successMessage);
          this.timeCodeStart = false;
          this.timeCodeStop = false;
          this.timeCodeStartTime = { hour: 0, minute: 0, second: 0 };
          this.timeCodeStopTime = { hour: 0, minute: 0, second: 0 };
          this.getCurrentWO();
          this.getTimeCodeDetails(this.mechanicId, this.d);

        }).finally(() => {
          this.spinner.hide();
        });
    }
    else {
      return
    }
  }
  startJobTimer() {
    if ((this.selectedWO?.length > 0 || this.workOrderNumber?.length > 0) && this.appointmentJobId > 0) {
      this.spinner.show();
      this.service.StartJobTimer(this.mechanicJobTimerModel).then(_respons => {
        let successMessage = this.translate.instant('lblStarted');
        this.toastr.success(successMessage);
        this.timeCodeStart = false;
        this.timeCodeStop = false;
        this.timeCodeStartTime = { hour: 0, minute: 0, second: 0 };
        this.timeCodeStopTime = { hour: 0, minute: 0, second: 0 };
        this.getCurrentWO();

        this.getTimeCodeDetails(this.mechanicId, this.d);
      }).finally(() => {
        this.spinner.hide();
      });
    }
    else {
      return
    }
  }
  startJobDetailTimer() {
    if ((this.workOrderNumber?.length > 0 || this.selectedWO?.length > 0 ) && this.appointmentJobId > 0 && this.appointmentJobDetailId > 0) {
      this.spinner.show();
      this.service.StartJobDetailTimer(this.mechanicJobTimerModel).then(_respons => {
        let successMessage = this.translate.instant('lblStarted');
        this.toastr.success(successMessage);
        this.timeCodeStart = false;
        this.timeCodeStop = false;
        this.timeCodeStartTime = { hour: 0, minute: 0, second: 0 };
        this.timeCodeStopTime = { hour: 0, minute: 0, second: 0 };
        this.getCurrentWO();

        this.getTimeCodeDetails(this.mechanicId, this.d);
      }).finally(() => {
        this.spinner.hide();
      });
    }
    else {
      return;
    }
  }
  onWOSummaryButton(woSummary) {
    this.isWOSummary = true;
    this.spinner.show();
    this.service
      .GetWorkOrderDetails(this.mechanicId, this.workOrderNumber)
      .then(res => {
        this.workOrderSummaryList = res;
        this.modalService
          .open(woSummary, {
            ariaLabelledBy: 'modal-basic-title',
            windowClass: 'summary-popup'
          })
          .result.then(
            result => {
              this.closeResult = `Closed with: ${result}`;
            },
            reason => {
              this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
          );
      }).finally(() => {
        this.spinner.hide();
      });
  }
  onWOStopButton(stopTime) {
    if(stopTime?.hour == 0 && stopTime?.minute == 0)
      {
        this.toastr.error(this.translate.instant("lblValidTime"));
      }
    else{
    var startTime = new Date();
    startTime.setHours(this.startTime.hour)
    startTime.setMinutes(this.startTime.minute)
    var stopDateTime = new Date();
    stopDateTime.setHours(stopTime.hour)
    stopDateTime.setMinutes(stopTime.minute)
    if (this.compareOnlyDate(this.selectedStartTime, stopDateTime)) {
      this.woStop(startTime, stopDateTime, stopTime);
    }
    else {
      let modelHeadermsg = this.translate.instant("lblConfirmation");
      let modelBodymsg = this.translate.instant("lblTimeofpastdate") + ' ' + Utility.GetFormattedDate(this.selectedStartTime) + ', ' + this.translate.instant("lblAreyousuretoupdate");
      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then((_result) => {
        // This is intentional
      }, (reason) => {
        this.closeModel = this.getDismissReason(reason);
        if (this.closeModel) {
          this.woStop(startTime, stopDateTime, stopTime);
        }
      })
    }
  }
  }
  woStop(startTime, stopDateTime, stopTime) {
    //var isBetweenShift = Utility.IsInBetweenDateTime(this.shiftStartTime, this.shiftEndTime, stopDateTime);
    //if (startTime < stopDateTime && (!this.stampInOutRequestModel.normal || isBetweenShift)) {
    if (startTime < stopDateTime) {
      this.d.setHours(stopTime.hour);
      this.d.setMinutes(stopTime.minute);
      let date = new Date(this.selectedStartTime);
      date.setHours(stopTime.hour);
      date.setMinutes(stopTime.minute);
      this.woSummaryButton = false;
      this.mechanicWorkOrderTimerModel.mechanicId = this.mechanicId;
      this.mechanicWorkOrderTimerModel.appointmentId = this.appointmentId;
      this.mechanicWorkOrderTimerModel.startTime = date
      this.mechanicJobTimerModel.mechanicId = this.mechanicId;
      this.mechanicJobTimerModel.appointmentId = this.appointmentId;
      this.mechanicJobTimerModel.appointmentJobId = this.appointmentJobId;
      this.mechanicJobTimerModel.appointmentJobDetailId = this.appointmentJobDetailId;
      this.mechanicJobTimerModel.time = date;

      //#region  If workorder feature is on
      if (this.isWorkorderTimer && !this.isJobDetailsTimerFeature) {
        if (this.isJobTimer) {
          this.stopJobTimer()
        } else {
          this.stopWorkorderTimer();
        }
      }
      //#endregion

      //#region If JobDetails feature is on
      if (!this.isWorkorderTimer && this.isJobDetailsTimerFeature) {
        //#region  Job details timer
        if (this.isJobDetailTimer) {
          this.stopJobDetailTimer()
        }
        //#endregion
        //#region Job timer
        else if (this.isJobTimer && !this.isJobDetailTimer) {
          this.stopJobTimer()
        }
        //#endregion
      }
      //#endregion

      //#region  If Workorder timer + JobDetail time feature both on
      if (this.isWorkorderTimer && this.isJobDetailsTimerFeature) {
        //#region  Job details timer
        if (this.isJobDetailTimer) {
          this.stopJobDetailTimer();
        }
        //#endregion
        //#region Job timer
        else if (this.isJobTimer && !this.isJobDetailTimer) {
          this.stopJobTimer();
        }
        //#endregion
        //#region Workorder timer
        else {
          this.stopWorkorderTimer();

        }
        //#endregion
      }
      //#endregion

      this.WoCounter = 0;
      this.assignedWork = null;
      this.selectedWO = null;
      this.selectedJob = null;
      this.selectedJobDetail = null;
      this.appointmentJobDetailId = 0;
      this.startTime = { hour: 0, minute: 0, second: 0 };
      this.stopTime = { hour: 0, minute: 0, second: 0 };
      this.timeCodeStartTime = { hour: 0, minute: 0, second: 0 };
      this.timeCodeStopTime = { hour: 0, minute: 0, second: 0 };
    }

    else {
      let warningMessage = this.translate.instant('lblEndTimeWarning');
      this.toastr.warning(warningMessage);
    }
  }

  stopWorkorderTimer() {
    this.spinner.show();
    this.service
      .StopWorkOrderTimer(this.mechanicWorkOrderTimerModel)
      .then(_response => {
        let successMessage = this.translate.instant('lblStopped');
        this.toastr.success(successMessage);
        this.WoSelect = true;
        this.woStartButton = true;
        this.woStopButton = false;
        this.getTimeCodeDetails(this.mechanicId, this.d);
      }).finally(() => {
        this.spinner.hide();
      });
  }
  stopJobTimer() {
    this.spinner.show();
    this.service.StopJobTimer(this.mechanicJobTimerModel).then(_res => {
      let successMessage = this.translate.instant('lblStopped');
      this.toastr.success(successMessage);
      this.WoSelect = true;
      this.woStartButton = true;
      this.woStopButton = false;
      this.getTimeCodeDetails(this.mechanicId, this.d);
    }).finally(() => {
      this.spinner.hide();
    });
  }
  stopJobDetailTimer() { 
    this.spinner.show();
    this.service.StopJobDetailTimer(this.mechanicJobTimerModel).then(_res => {
      let successMessage = this.translate.instant('lblStopped');
      this.toastr.success(successMessage);
      this.WoSelect = true;
      this.woStartButton = true;
      this.woStopButton = false;
      this.getTimeCodeDetails(this.mechanicId, this.d);
    }).finally(() => {
      this.spinner.hide();
    });
  }
  EditTimerDetails(summaryContent, item) {
    this.summaryReason = item.reason;
    this.FromDate = Utility.GetFormattedDate(item.startDateTime);
    this.FromTimeObj = { hour: +item.startDateTime.getHours(), minute: +item.startDateTime.getMinutes() };
    this.TimeToDate = (item.endDateTime instanceof Date && !isNaN(item.endDateTime)) ? Utility.GetFormattedDate(item.endDateTime) : this.FromDate;
    this.ToTimeObj = { hour: +item.endDateTime.getHours(), minute: +item.endDateTime.getMinutes() };
    this.mechanicService.entityId = item.entityId;
    this.mechanicService.timeCodeType = item.timeCodeType;
    this.mechanicService.appointmentId = item?.appointmentId;
    this.mechanicService.appointmentJobId = item?.jobId;
    this.mechanicService.description = item?.description;
    this.closeModel = this.modalService.open(summaryContent, { size: 'lg', windowClass: 'EditPopup1' })
    this.closeModel.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  DeleteTimerDetails(item: any) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblSummary"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.closeModel = this.getDismissReason(reason);
      if (this.closeModel) {
        let deleteModel = {
          timeCodeType: item.timeCodeType,
          entityId: item.entityId,
          startTime: item?.startDateTime,
          endTime: item?.endDateTime,
          appointmentId: item?.appointmentId
        }
        this.service.DeleteSummaryDetails(deleteModel).then((res) => {
          if (res) {
            let successMsg = this.translate.instant("lblSummaryDeleted");
            this.toastr.success(successMsg);
            this.WoSelect = true;
            this.woStartButton = false;
            this.woStopButton = false;
            this.timeCodeStart = false;
            this.timeCodeStop = false;
            this.selectedWO = null;
            this.assignedWork = null;
            this.selectedJob = null;
            this.getTimeCodeDetails(this.mechanicId, this.d);
          }
          else {
            let errorMsg = this.translate.instant("lblSummaryNotDeleted");
            this.toastr.error(errorMsg);
          }
        })
      }
    });
  }

  EditSummaryDetails() {
    let timeFrom = Utility.getDateStringToDate(this.frm.timefrom.value);
    timeFrom.setHours(this.FromTimeObj.hour);
    timeFrom.setMinutes(this.FromTimeObj.minute);

    let timeTo = Utility.getDateStringToDate(this.frm.timeto.value);
    timeTo.setHours(this.ToTimeObj.hour);
    timeTo.setMinutes(this.ToTimeObj.minute);

    if (isNaN(this.ToTimeObj.hour) ||  timeTo < timeFrom) {
      let ErrorMsg = this.translate.instant("lblTimeTohoursShouldgretar");
      this.toastr.error(ErrorMsg);
    }
    else {
      let editModel = {
        timeFrom: timeFrom,
        timeTo: timeTo,
        reason: this.frm.reason.value,
        entityId: this.mechanicService.entityId,
        timeCodeType: this.mechanicService.timeCodeType,
        mechanicId: this.mechanicId,
        appointmentId: this.mechanicService.appointmentId,
        appointmentJobId: this.mechanicService.appointmentJobId,
        isStart: this.woStartButton ? true : false,
        description: this.mechanicService.description
      }

      this.service.CheckTimerDetails(editModel).then((result) => {
        if (result?.responseObject == 1) {
          let modelHeadermsg = this.translate.instant("lblConfirmation");
          let modelBodymsg = this.translate.instant("lblTimeisconflictareusuretochange?");
          const modalRef = this.modalService.open(NgbdModalContent, { windowClass: 'EditPopup2' });

          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = modelBodymsg;
          modalRef.result.then((_result) => {
            // This is intentional
          }, (reason) => {
            this.popupCloseResult = this.getDismissReason(reason);
            if (this.popupCloseResult) {
              this.UpdateSummaryDetails(editModel);
            }
          });
        }
        if (result?.responseObject == 2) {
          let modelHeadermsg = this.translate.instant("lblConfirmation");
          let modelBodymsg = this.translate.instant("lblTimeIsnotbetweenshifareyousuretochange?");
          const modalRef = this.modalService.open(NgbdModalContent, { windowClass: 'EditPopup2' });
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = modelBodymsg;
          modalRef.result.then((_result) => {
            // This is intentional
          }, (reason) => {
            this.popupCloseResult = this.getDismissReason(reason);
            if (this.popupCloseResult) {
              this.UpdateSummaryDetails(editModel);
            }
          });
        }
        else if (result?.responseObject == 0) {
          this.UpdateSummaryDetails(editModel);
        }
      })
    }
  }

  UpdateSummaryDetails(editModel) {
    this.service.EditSummaryDetails(editModel).then((res) => {
      if (res) {
        if (res.responseObject == 0) {
          let successMsg = this.translate.instant("lblSummaryEdited");
          this.toastr.success(successMsg);
          this.WoSelect = true;
          this.woStartButton = false;
          this.woStopButton = false;
          this.timeCodeStart = false;
          this.timeCodeStop = false;
          this.selectedWO = null;
          this.assignedWork = null;
          this.selectedJob = null;
          this.getTimeCodeDetails(this.mechanicId, this.d);
        }
        if (res.responseObject == 2) {
          let msg = this.translate.instant("lbltimeisclasingwithlunch");
          this.toastr.error(msg);
        }
        if (res.responseObject == 1) {
          let msg = this.translate.instant("lbltimeisclasingwithleave");
          this.toastr.error(msg);
        }
        if (res.responseObject == 3) {
          let msg = this.translate.instant("lbltimeisclasingwithnotavailble");
          this.toastr.error(msg);
        }
        if (res.responseObject == 4) {
          let msg = this.translate.instant("lbltimeisclasingwithshifttime");
          this.toastr.error(msg);
        }
        this.closeModel.close();
      }
      else {
        let errorMsg = this.translate.instant("lblSummaryNotEdited");
        this.toastr.error(errorMsg);
      }
    })
  }
  stampIn(data: any) {
    this.openingTimeHour = data.stampIn.getHours();
    this.openingTimeMinute = data.stampIn.getMinutes();
    if (this.openingTimeMinute >= 45 && this.openingTimeMinute <= 60) {
      this.openingTimeMinute = 0;
      if (this.openingTimeHour !== 23) {
        this.openingTimeHour = this.openingTimeHour + 1;
      }
      else {
        this.openingTimeHour = 0
      }
    }
    data.inTimePicker = !data.inTimePicker;
    this.getAll();
  }
  onChangeInTimeHours(data: any, event: any) {
    let inTime = Utility.getDateStringToDate(this.stampInDate);
    inTime.setHours(+event.split(":")[0], +event.split(":")[1], 0);
    if(data.stampOut != null){
      if(inTime > data.stampOut)
      {
        let warningMessage = this.translate.instant('lblStartTimeGraterWarning');
        this.toastr.warning(warningMessage);
        return;
      }
      else{
        this.updateStampInTime(data,inTime);
        this.getAll();
      }
    }
    else{
      this.updateStampInTime(data,inTime);
      this.getAll();
    }
  }

  updateStampInTime(data: any, inTime: any) {
    let isBetweenShift = Utility.IsInBetweenDateTime(this.shiftStartTime, this.shiftEndTime, inTime);
    let model = {
      Id: data.id,
      StampIn: inTime,
      StampOut: data.stampOut != null ? new Date(data.stampOut) : null,
      MechanicId: this.mechanicId
    }
    this.spinner.show();
    this.service.UpdateMechanicStampOutDetails(model).then((res) => {
      if (res.responseObject) {
        this.woStartButton = false;
        this.woStopButton = false;
        this.timeCodeStart = false;
        this.timeCodeStop = false;
        this.assignedWork = null;
        this.selectedWO = null;
        this.selectedJob = null;
        this.selectedDayType = 1;
        this.WoSelect = false;
        this.woSummaryButton = false;
        this.timeCodeStartTime = { hour: 0, minute: 0, second: 0 };
        this.timeCodeStopTime = { hour: 0, minute: 0, second: 0 };
        this.getMechanicStampInOutDetails(this.d);
      }
      else {
        let msg = this.translate.instant('lblStampOutTimeNotLesserThenJobEndTime');
        this.toastr.error(msg);
      }
    }).finally(() => {
      this.spinner.hide();
    });
    if (!isBetweenShift) {
      let warningMessage = this.translate.instant('lblStartTimeWarning');
      this.toastr.warning(warningMessage);
    }
  }

  compareOnlyDate(date1, date2) {
    // Get the date part of the Date objects
    const day1 = new Date(date1).getDate();
    const month1 = new Date(date1).getMonth();
    const year1 = new Date(date1).getFullYear();

    const day2 = new Date(date2).getDate();
    const month2 = new Date(date2).getMonth();
    const year2 = new Date(date2).getFullYear();

    // Compare the dates
    if (year1 === year2 && month1 === month2 && day1 === day2) {
      return true;
    } return false;
  }
  checkValidation() {
    if (this.isWorkorderTimer) {

    }
  }
  //#endregion
}
